import { Vector3, type Camera } from 'three'

export const getNeutralLightPosition = (
    camera:Camera,
    cameraDirection:Vector3,
    lightDistance:number,
    fabricLighting:boolean,
):Vector3 => {
    const position = camera.position.clone().addScaledVector(cameraDirection, lightDistance)
    if(!fabricLighting) return position

    // A camera-aligned key hides relief and keeps specular highlights facing
    // the viewer. Move the textile key left and up in the camera's own frame.
    const right = new Vector3(1, 0, 0).applyQuaternion(camera.quaternion)
    const up = new Vector3(0, 1, 0).applyQuaternion(camera.quaternion)
    return position
        .addScaledVector(right, -Math.abs(lightDistance) * 1.2)
        .addScaledVector(up, Math.abs(lightDistance) * 0.3)
}
